export default "__VITE_PUBLIC_ASSET__33843ecc__"